import type { PaymentSplit } from "@/api/payment-split";

export interface ClaimPillSpec {
  kind: "paid" | "pending_cash";
  label: string;
}

/**
 * What the existing shares on one line mean for the guest choosing theirs.
 * Only live shares hold a line: `released` (checkout abandoned or expired) and
 * `failed` give it back — they used to read "Paid" and lock it for good.
 */
export function lineClaimState(
  lineSplits: Pick<PaymentSplit, "state" | "claimedByGuestId">[],
  selfId: string,
): { locked: boolean; pills: ClaimPillSpec[] } {
  const pills: ClaimPillSpec[] = [];
  let locked = false;
  for (const sp of lineSplits) {
    const you = sp.claimedByGuestId === selfId;
    if (sp.state === "paid") {
      locked = true;
      pills.push({ kind: "paid", label: you ? "You (Paid)" : "Paid" });
    } else if (sp.state === "processing") {
      locked = true;
      pills.push({ kind: "pending_cash", label: you ? "You (Paying…)" : "Paying…" });
    } else if (sp.state === "awaiting_collection") {
      locked = true;
      pills.push({ kind: "pending_cash", label: you ? "You (Cash)" : "Pending Cash" });
    }
  }
  return { locked, pills };
}
